module.exports = __webpack_public_path__ + "img/UI_suofang_icon_01_f64d65cd6.png";